import { Time } from '../common/Enumerations';
import { InstantPushConfig } from '../config/push/InstantPushConfig';
import { PushConfig } from '../config/push/PushConfig';

export class DateCalculator {
	public static calculateInitialTimedPushDate(pushConfig: PushConfig): number {
		return this._calculateNextSurveyDate(pushConfig.intervalInitialTimedPushInDays, pushConfig.deviationInitialTimedPushInDays);
	}

	public static calculateInitialAppPushDate(pushConfig: PushConfig): number {
		return this._calculateNextSurveyDate(pushConfig.intervalInitialAppPushInDays, pushConfig.deviationInitialAppPushInDays);
	}

	public static calculateNextTimedPushDate(pushConfig: PushConfig): number {
		return this._calculateNextSurveyDate(pushConfig.intervalNextTimedPushInDays, pushConfig.deviationNextTimedPushInDays);
	}

	public static calculateNextAppPushDate(pushConfig: PushConfig): number {
		return this._calculateNextSurveyDate(pushConfig.intervalNextAppPushInDays, pushConfig.deviationNextAppPushInDays);
	}

	public static calculateNextInstantPushDate(instantPushConfig: InstantPushConfig): number {
		return Date.now() + instantPushConfig.quietPeriodInHrs * Time.hoursToMilliseconds;
	}

	private static _calculateNextSurveyDate(dayInterval: number, dayDeviation: number): number {
		const daysToBeAddedToNow = dayInterval + Math.round(Math.random() * dayDeviation * 2) - dayDeviation;
		return Date.now() + daysToBeAddedToNow * Time.daysToMilliseconds;
	}
}
